import { useCallback, useState } from 'react'

import { useUnit } from 'effector-react'

import PpvIcon from '@/assets/icons/icon-ppv.svg'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { $creatorId } from '@/models/creators'
import { $openedDialogs } from '@/models/dialogs'
import { TrackedFeatures, trackFeatureUsage } from '@/utils/feature-engagement'

import { IconButton } from '../../components/icon-button'
import { OverviewWrapper } from './overview-wrapper/OverviewWrapper'

export const PpvOverview = () => {
  const dialogs = useUnit($openedDialogs)
  const creatorId = useUnit($creatorId)
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenChange = useCallback(() => {
    // do not close popover if media dialog is open
    if (dialogs.length) {
      return
    }
    const shouldOpen = !isOpen

    if (shouldOpen) {
      trackFeatureUsage(TrackedFeatures.PpvOverview, creatorId)
    }
    setIsOpen(shouldOpen)
  }, [dialogs.length, isOpen, creatorId])

  return (
    <Popover
      open={isOpen}
      onOpenChange={handleOpenChange}
    >
      <PopoverTrigger
        asChild
        onClick={handleOpenChange}
      >
        <IconButton
          icon={PpvIcon}
          iconClassName="h-7 w-7"
          tooltip="PPV Overview"
        />
      </PopoverTrigger>
      <PopoverContent className="z-50 w-[816px]">
        <OverviewWrapper
          onClose={handleOpenChange}
          isOpen={isOpen}
        />
      </PopoverContent>
    </Popover>
  )
}
